import { Component } from '@angular/core';
import { IzzyTicketMergeEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Ticket Merges') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzyticketmerge-form',
    templateUrl: './izzyticketmerge.form.component.html'
})
export class IzzyTicketMergeFormComponent extends BaseFormComponent {
    public record!: IzzyTicketMergeEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'mergeParticipants', sectionName: 'Merge Participants', isExpanded: true },
            { sectionKey: 'mergeDetails', sectionName: 'Merge Details', isExpanded: true },
            { sectionKey: 'mergeLifecycle', sectionName: 'Merge Lifecycle', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

